export default {
  APPLIED: 'applied',
  DECLINED: 'declined',
  MEETING: 'meeting',
  ACCEPTED: 'accepted',
}